import { httpClient } from '../lib/http-client';
import { Prioridade } from '../types';

/**
 * Service para gerenciamento de prioridades
 */
export class PrioridadesService {
  static async getPrioridades(): Promise<Prioridade[]> {
    return httpClient.get<Prioridade[]>('/api/prioridades');
  }

  static async getPrioridade(id: number): Promise<Prioridade> {
    return httpClient.get<Prioridade>(`/api/prioridades/${id}`);
  }

  static async createPrioridade(data: Partial<Prioridade>): Promise<Prioridade> {
    return httpClient.post<Prioridade>('/api/prioridades', data);
  }

  static async updatePrioridade(
    id: number,
    data: Partial<Prioridade>
  ): Promise<Prioridade> {
    return httpClient.put<Prioridade>(`/api/prioridades/${id}`, data);
  }

  static async deletePrioridade(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/prioridades/${id}`);
  }
}

